import React, { Component } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast } from "react-toastify";

const ITEM_HEIGHT = 48;

class VerticalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = { ...this.props.state, deleteDialogOpen: false, disableDialogOpen: false }
  }

  handleContextClick = (event, n) => {
    const { t } = this.props;
    event.preventDefault();
    let disabledText;
    if ((n && n.is_enabled) === 'true' || (n && n.is_enabled) === true) {
      disabledText = t('Users.DisableActions');
    } else {
      disabledText = t('Report.inActive.Enable');
    }
    let disableUser = false;
    let currentUser = JSON.parse(sessionStorage.getItem('user')).username;
    if (n.id === currentUser) {
      disableUser = true;
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.id,
      disabledText: disabledText,
      isDisabled: disableUser,
    });
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    }
    this.setState({ deleteDialogOpen: false });
    toast.success(this.props.t('Toast.Success.UserRemoved'));
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    const result = fetch(
      process.env.REACT_APP_BASEURL + 'users/' + rowIdToDelete,
      {
        method: 'DELETE',
        withCredentials: true,
        headers: {
          'Content-Type': 'application/json',
          Authorization:
            'Bearer ' +
            JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
              .jwtToken,
        },
      }
    );
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
      this.setState({
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
        selectedRowId: null,
      });
      const filteredObject = {
        data: JSON.parse(JSON.stringify(newData)),
        selected: [],
        selectedRowId: null,
      }
      this.props.retrieveData(filteredObject)
      this.handleContextClose(event);
      this.props.params.api.refreshServerSide();
    });
  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    const filteredObject = {
      selectedTab: 0,
      showNewUserDialog: true,
      operation: 'View',
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      badge_id: selectedObject.badge_id,
      email: selectedObject.email || selectedObject.contact.email,
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.phone || selectedObject.contact.phone,
      roles: selectedObject.roles,
      // -- Need to enable when we deployed appointments.
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      workDayStarts:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.work_day_starts,
      workDayEnds:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.work_day_ends,
      reminderSelectID:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.reminder,
      defaultReminder:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_default_reminder,
      sunday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sunday,
      monday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_monday,
      tuesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_tuesday,
      wednesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_wednesday,
      thursday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_thursday,
      friday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_friday,
      saturday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_saturday,
      emailNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_email,
      smsNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sms,
      pushNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_push,
      preferLanguage: selectedObject && selectedObject.preferred_language,
    };
    this.props.retrieveData(filteredObject);
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    const filteredObject = {
      selectedTab: 0,
      showNewUserDialog: true,
      operation: 'Edit',
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      badge_id: selectedObject.badge_id,
      email: selectedObject.email || selectedObject.contact.email,
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.phone || selectedObject.contact.phone,
      roles: selectedObject.roles,
      // -- Need to enable when we deployed appointments.
      rowID: selectedObject && selectedObject.id,
      parentID: selectedObject && selectedObject.parent_account_id,
      workDayStarts:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.work_day_starts &&
          selectedObject.scheduleCalendar.work_day_starts !== null &&
          selectedObject.scheduleCalendar.work_day_starts !== 'null' &&
          selectedObject.scheduleCalendar.work_day_starts !== undefined &&
          selectedObject.scheduleCalendar.work_day_starts !== 'undefined'
          ? selectedObject.scheduleCalendar.work_day_starts
          : new Date(),
      workDayEnds:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.work_day_ends &&
          selectedObject.scheduleCalendar.work_day_ends !== null &&
          selectedObject.scheduleCalendar.work_day_ends !== 'null' &&
          selectedObject.scheduleCalendar.work_day_ends !== undefined &&
          selectedObject.scheduleCalendar.work_day_ends !== 'undefined'
          ? selectedObject.scheduleCalendar.work_day_ends
          : new Date(),
      reminderSelectID:
        selectedObject &&
          selectedObject.scheduleCalendar &&
          selectedObject.scheduleCalendar.reminder &&
          selectedObject.scheduleCalendar.reminder !== null &&
          selectedObject.scheduleCalendar.reminder !== 'null' &&
          selectedObject.scheduleCalendar.reminder !== undefined &&
          selectedObject.scheduleCalendar.reminder !== 'undefined' &&
          selectedObject.scheduleCalendar.reminder !== ''
          ? selectedObject.scheduleCalendar.reminder
          : this.state.reminderSelectID,
      defaultReminder:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_default_reminder,
      sunday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sunday,
      monday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_monday,
      tuesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_tuesday,
      wednesday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_wednesday,
      thursday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_thursday,
      friday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_friday,
      saturday:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_saturday,
      emailNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_email,
      smsNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_sms,
      pushNotify:
        selectedObject &&
        selectedObject.scheduleCalendar &&
        selectedObject.scheduleCalendar.is_push,
      preferLanguage: selectedObject && selectedObject.preferred_language,
    };
    this.props.retrieveData(filteredObject);
    this.handleContextClose(event);
  };

  confirmDelete = (event) => {
    // this.forDeletion
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  //user disable
  confirmDisable = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  disableConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
    }
  };

  disableConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDisable(event);
    }
    this.setState({ disableDialogOpen: false });
    toast.success(
      `${this.props.t('Toast.User')} ${this.state && this.state.disabledText} ${this.props.t('Toast.Success')}`
    );
  };

  handleDisable = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state && this.state.disabledText.toLowerCase() === 'disable'
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + 'userdis/', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        return null;
      }
    });
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.props.params.api.refreshServerSide();
    });
  };

  //user disable
  confirmResetPSWD = (event) => {
    let selectedObject = {};
    if (this.state.selectedRowId) {
      selectedObject = this.state.data.find(
        (x) => x.id === this.state.selectedRowId
      );
    } else {
      selectedObject = this.state.data.filter(
        (x) => this.state.selected.indexOf(x.id) > -1
      );
    }
    console.log('Confirm Reset Password for', {
      selectedObject,
      selecteddID: this.state.selectedRowId,
    });
    fetch(process.env.REACT_APP_BASEURL + 'adminUser-pswdReset', {
      method: 'POST',
      withCredentials: true,
      headers: {
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        email: selectedObject && selectedObject.username,
      }),
    })
      .then((res) => res.json())
      .then((res) => {
        console.log({ confirmResetPSWD_res: res });
        this.handleContextClose(event);
        toast.success(this.props.t('Toast.Request.ResetPassword'));
      })
      .catch((err) => {
        console.error(err);
        toast.error(err.message);
      });
  };

  handleUnlockUser = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    this.setState({ selectedUserEmailToAuthenticat: selectedObject.username, authenticateUnlockUserDialogConfirmation: true, loader: false }, () => {
      console.log(this.state.selectedUserEmailToAuthenticat);
    })
    this.handleContextClose(event);
  }
  
  handleAuthenticateUnlockUserDialogConfirmationClose = () => {      
    this.setState({ authenticateUnlockUserDialogConfirmation: false })
  }

  processUserUnlock = () => {
    const { selectedUserEmailToAuthenticat } = this.state;
    let _apiEndPoint = `${process.env.REACT_APP_BASEURL}connect/auth/user/reset-request`;
    fetch(_apiEndPoint, {
      method: 'POST',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify({ email: selectedUserEmailToAuthenticat })
    })
      .then((response) => response.json())
      .then((eventResponse) => {
        this.props.params.api.refreshServerSide();
        console.info(`Response from reset-request ${JSON.stringify(eventResponse, null, 2)}`)
        this.setState({
          authenticateUnlockUserDialogConfirmation: false,
          loader: false
        })
      }).catch((error) => {
        console.info(`Error response from reset-request ${JSON.stringify(error, null, 2)}`)
        this.setState({
          authenticateUnlockUserDialogConfirmation: false,
          loader: false
        })
        toast.error(error.message + ': ' + error.errorMessage);
      })
  }

  render() {
    const { classes, t, params } = this.props;
    const { anchorEl, userview, useredit, userdelete, isSuperAdmin, isAdmin, isDisabled, disabledText, forDisable, disableDialogOpen, forDeletion, deleteDialogOpen } = this.state;
    const contextOpen = Boolean(anchorEl)

    return (
      <div>
        {/* delete dialog start */}
        <Dialog
          open={deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Users.AreYouSureDeleteText')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Users.AreYouSureDeleteBodyText')} :
              <ul>
                {forDeletion &&
                  forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteCancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Users.AreYouSureDeleteButton')}
            </Button>
          </DialogActions>
        </Dialog>
        {/* delete dialog end */}
        <Dialog
          open={disableDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{`Are you sure you want to ${disabledText}?`}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Users.AreYouSureWantTo')}{' '}
              {disabledText} {t('Users.users')}:
              <ul>
                {forDisable &&
                  forDisable.map(function (x) {
                    return <li>{x.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.disableConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Users.CancelButton')}
            </Button>
            <Button
              onClick={this.disableConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Users.YES')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.authenticateUnlockUserDialogConfirmation || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogContent>
            <DialogContentText>              
              <p>
                {t('Account.Terms.PurgeServicePopupFinalConfirmationMessage')}
              </p>                  
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(event) => this.processUserUnlock(event)}
              color='primary'
              disabled={this.state.loader === true}
            >
              {t('Global.Consultation.Action.Yes')}
            </Button>
            <Button
              onClick={(event) => this.handleAuthenticateUnlockUserDialogConfirmationClose(event)}
              color='primary'
              disabled={this.state.loader === true}
            >
              {t('Global.Consultation.Action.No')}
            </Button>
          </DialogActions>
        </Dialog>
        <IconButton
          aria-label='More'
          aria-owns={contextOpen ? 'long-menu' : null}
          aria-haspopup='true'
          onClick={(event) => this.handleContextClick(event, params.data)}
        >
          <MoreVertIcon style={{ fontSize: 20 }} />
        </IconButton>
        <Menu
          id='long-menu'
          anchorEl={anchorEl}
          open={contextOpen}
          onClose={this.handleContextClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
            },
          }}
        >
          {userview === true && (
            <MenuItem
              key='view'
              onClick={this.handleView}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Users.ViewActions')}</ListItemText>
            </MenuItem>
          )}
          {useredit === true && (
            <MenuItem
              key='edit'
              onClick={this.handleEdit}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Users.EditActions')}</ListItemText>
            </MenuItem>
          )}
          {userdelete === true && (
            <MenuItem
              disabled={isDisabled === true}
              key='delete'
              onClick={this.confirmDelete}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Users.DeleteActions')}</ListItemText>
            </MenuItem>
          )}
          {userdelete === true && (
            <MenuItem
              key='Disable'
              disabled={isDisabled === true}
              onClick={this.confirmDisable}
              sx={{ height: '40px' }}
            >
              <ListItemText>
                {disabledText}
              </ListItemText>
            </MenuItem>
          )}
          {(isSuperAdmin || isAdmin) && (
            <MenuItem
              key='Reset Password'
              onClick={this.confirmResetPSWD}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Users.ResetPasswordActions')}</ListItemText>
            </MenuItem>
          )}
          {useredit && (
            <MenuItem
              key='Unlock User'
              onClick={this.handleUnlockUser}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Users.UnlockUser')}</ListItemText>
            </MenuItem>
          )}
        </Menu>
      </div>
    )
  }
}

export default VerticalMenu;



// WEBPACK FOOTER //
// ./src/components/user-list/ActionCellRenderer.js